import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Grid, Popup, Icon, Button, TextArea} from 'semantic-ui-react';
import {ordersStatus} from '../../../../common/dictionaries/accessories';
import {Actions} from '../../../../common/actions';
import './cancel.scss';

class CancelOrderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'cancelReason': '',
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.handleCancelReasonChange = this.handleCancelReasonChange.bind(this);
  }

  fetchData() {
    this.setState({'modalWasOpen': true});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }
  
  onCancelClick() {
    const {accessoryOrder, type, filters} = this.props;
    const {date, chassis, status, invoiceType} = filters;
    const {cancelReason} = this.state;
    const data = {chassis, type, date, cancelReason, status, invoiceType};
    this.props.cancelOrder(accessoryOrder.order, data);
    this.onCloseModalClick();
  }

  handleCancelReasonChange(event, {value}) {
    this.setState({'cancelReason': value});
  }

  orderHasTimeMarked = (accessoryOrder, type) => {
    if (type === 'pds') {
      return accessoryOrder.status === ordersStatus.closed_order_not_billable;
    }
    return accessoryOrder.status === ordersStatus.wash_wait;
  }

  render() {
    const {accessoryOrder, type} = this.props;
    const {modalWasOpen, cancelReason} = this.state;
    const hasTimeMarked = this.orderHasTimeMarked(accessoryOrder, type);
    const title = hasTimeMarked ? 'los tiempos de' : '';

    return (
      <Modal size='tiny' className='cancel-order-modal'
        onOpen={() => this.fetchData()}
        open={modalWasOpen}
        centered
        trigger={
          <span className='link'>
            <Popup
              trigger={
                <Icon name={hasTimeMarked ? 'auto_delete' : 'delete'}
                  color={type === 'qualityAssurance' ? 'blue' : 'grey'} size='large' />
              }
              content={`Anular${hasTimeMarked ? ' Tiempos' : ''}`}
              position='top center'
              inverted
            />
          </span>
        }>
                
        <Modal.Header>
          ¿Está seguro que desea anular {title} la orden {accessoryOrder.order}?
        </Modal.Header>
        
        <Modal.Content>
          <div className='title-bar'>
            <div className='filters-section'>
              <Grid textAlign='left'>
                {hasTimeMarked &&
                <Grid.Row>
                  <Grid.Column width={16}>
                    <div className='required'>Este procedimiento automáticamente anulará la orden</div>
                  </Grid.Column>
                </Grid.Row>
                }
                <Grid.Row>
                  <Grid.Column width={16}>
                    <h4>Por favor ingrese la justificación para poder anular la orden
                      <span className='required'>*</span>:
                    </h4>
                    <TextArea maxLength='200' rows='4' value={cancelReason}
                      className={cancelReason ? '' : 'error'}
                      onChange={this.handleCancelReasonChange} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cancelar
          </Button>
          <Button positive
            disabled={!cancelReason}
            onClick={this.onCancelClick}>
            Confirmar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'date': state.accessoriesOrders.searchDate,
  };
};

const {
  cancelOrder,
} = Actions;

export default connect(mapStateToProps, {
  cancelOrder,
})(CancelOrderModal);
